import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Login from './Login.js';
import Signup from './Signup.js';
import Patient from './Patient.js';
import NewUser from './newUser.js';
import Userguide from './Userguide.js';
class Routes extends Component {


render(){
  return(
  <BrowserRouter>
    <Switch>
      <Route path={"/"} exact component={Login} />
      <Route path={"/patient/:doctor/:user"} exact render={({match}) => (
          <Patient
            user={match.params.user}
            doctor={match.params.doctor}
          />
)}/>
      <Route path={"/newuser"} exact component={NewUser}/>
      <Route path={"/signup"} exact component={Signup} />
      <Route path={"/userguide"} exact component={Userguide} />
    </Switch>
  </BrowserRouter>
);
}
}
export default Routes;



// WEBPACK FOOTER //
// ./src/routes/index.js